import React from 'react'
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';

function CsplLabel(props) {
    const {t} = useTranslation('common');
  return (  
    <label>{props.params ?  t(props.label, props.params)  : t(props.label) }</label>
  )
}
CsplLabel.propTypes ={
    label : PropTypes.string
}

export default CsplLabel